// extracted by mini-css-extract-plugin
export default {"sidebar-content-listitem":"ControllerSideBar_sidebar-content-listitem__H3psY"};